import { getDateRange } from "./datetime"

// Build a query string from a filters object, dropping undefined/empty values.
export const buildQueryString = (filters = {}) =>
  new URLSearchParams(
    Object.fromEntries(
      Object.entries(filters).filter(
        ([, v]) => v !== undefined && v !== null && v !== ""
      )
    )
  ).toString()

export const generateFilter = (filters) =>
  filters
    .filter((f) => f.value !== "All")
    .map((f) => {
      if (
        f.id === "createdAt" ||
        f.id === "CreatedAt" ||
        f.id === "LastUpdatedAt"
      ) {
        const interval = getDateRange(f.value)
        return {
          id: f.id,
          value: [interval.start.toISO(), interval.end.toISO()].join(","),
        }
      }
      if (f.id === "LogType") {
        const extractedLogType = getLogTypeBasedOnValue(f.value)
        return {
          id: f.id,
          value: extractedLogType,
        }
      }
      return { id: f.id, value: f.value.toLowerCase().trim() }
    })
    .reduce((acc, f) => {
      acc[f.id] = f.value
      return acc
    }, {})

export const getLogTypeBasedOnValue = (value) => {
  if (value === "Invalid XHTML") {
    return "ERROR_INVALID_XHTML"
  } else if (value === "Non Spine/Herniation Info Missing") {
    return "INFO_NON_CSP_LSP_REPORT"
  } else {
    return ""
  }
}

export const stringToBoolean = (str) => {
  if (typeof str === "string") {
    return str === "true"
  }

  return str
}

export const safeParseAiResponse = (value) => {
  if (!value || value === "undefined" || value === "null") return null
  const asValidObject = (parsed) =>
    parsed && typeof parsed === "object" && Object.keys(parsed).length > 0
      ? parsed
      : null
  try {
    return asValidObject(JSON.parse(value))
  } catch {
    try {
      const jsonish = value
        .replace(/\bTrue\b/g, "true")
        .replace(/\bFalse\b/g, "false")
        .replace(/\bNone\b/g, "null")
        .replace(/'/g, '"')
      return asValidObject(JSON.parse(jsonish))
    } catch {
      return null
    }
  }
}
